import { render, staticRenderFns } from "./ListCompaniesAverageVotes.vue?vue&type=template&id=5946dc4c&scoped=true&"
import script from "./ListCompaniesAverageVotes.vue?vue&type=script&lang=js&"
export * from "./ListCompaniesAverageVotes.vue?vue&type=script&lang=js&"
import style0 from "./ListCompaniesAverageVotes.vue?vue&type=style&index=0&id=5946dc4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946dc4c",
  null
  
)

export default component.exports